<template>
    <div id="appointmentCenter" style="height:100%">
        <m-search-list :popPrefix="popPrefix" ref="searchList" :searchId="searchId" :list="config.searchList" :searchTotalTitle="searchTotalTitle" :optionNum="optionNum" :initSearchInfo="initSearchInfo"
                       :configurationUrl="configurationUrl" :longPrefix="longPrefix" :advancePrefix="advancePrefix" :searchSetTitle="searchSetTitle" :dynamicUpdateQuery="config.dynamicUpdateQuery"
                       @onSearchChange="searchChange" @tableAdvance="tableAdvance" @search-list-change="searchListChange"
                       @searchSet-change="searchSetChange">
          <span slot="search-list-advance-right">
              <slot name="search-list-advance-right"></slot>
          </span>
          <div slot="table-module-btn" class="btn-box">
            <slot name="table-module-btn"></slot>
            <el-tooltip v-if="config.configuration?false: true" class="item allocation-box" effect="dark" content="列配置" placement="bottom">
              <el-button size="mini" class="el-icon-setting" @click="getTitleList"></el-button>
            </el-tooltip>
            <el-dialog :visible.sync="showModal" title="列配置" @close="dialogClose">
              <configuration :checkedList="checkedList" :selectAllColumns="config.table.columns" ref="dialog"
                             @getTableConfigList="getTableConfigList" @tableConfigClose="tableConfigClose" :columnNum='columnNum'></configuration>
            </el-dialog>
          </div>
        </m-search-list>
        <div slot="table-top">
              <slot name="table-top"></slot>
        </div>
        <div class="all-tables">
            <div class="all-table-left" ref="allTableLeft">
                <div class="lr-drag" ref="lrDragWidth" @mousedown.stop.prevent="mousedownLRWidth"></div>
                <div class='list-top' v-if="config.table.seperateTree">
                    <div class="list-title">{{sourceTitle}}</div>
                    <ul class='table-lists' ref="topLists"><el-main v-loading="sourceTreeLoading">
                        <el-scrollbar>
                        <li class="list-details" v-for="(item, index) in sourceRootData" :key="index"
                            :class="{ 'active': mulSourceSel ? item.isActive : 'source'+index == sourceCurrent}"
                            @click="rootListClick(item, 'source', index)">{{item.textLeft}}</li>
                        </el-scrollbar>
                    </el-main></ul>
                </div>
            </div>
            <div class="all-table-right" ref="allTableRight">
                <m-table
                    ref="table"
                    class="source-table"
                    :popPrefix="popPrefix"
                    :longPrefix="longPrefix"
                    :verification="verification"
                    :tableConfig="config.table"
                    :tableData="totalData"
                    :tableList="tableList"
                    :loading="sourceLoading"
                    @tab-advanced-search="tabAdvancedSearch"
                    @row-db-click="rowDBClick"
                    @save-data="saveData"
                    @btnView="checkTable"
                    @btnEdit="editTable"
                    @btnPrint="printTable"
                    @btnDelete="delTable"
                    @btnAllocate="allocateTable"
                    @btnCancleAllocate="cancleAllocateTable"
                    @onSelectionChange="sourceSelectChange"
                    @column-filter-search="columnFilterSearch"
                    @moreAction="moreAction"
                    @onCellDblclick="cellDblclick"
                    @row-click="sourceRowClick"
                    @select="sourceSelect"
                    @selectAll="sourceSelectAll"
                    @btnAllocation="allocationBtn"
                    @btnRemove="removeBtn"
                    @btnRescheduling="reschedulingBtn"
                    @btnAppointmentBranch="appointmentBranchBtn"
                    @btnRescheduledBranch="rescheduledBranchBtn"
                    @btn-click="btnClick"
                >
                    <template v-slot:customTableCell="scope">
                        <slot name="customTableCell" v-bind="scope"></slot>
                    </template>
                    <div slot="expand-table-content" slot-scope="{expandProps}"><slot name="expand-table-cont" :expandTable="expandProps"></slot></div>
                </m-table>
                <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="12" class="page-text">
                        <div v-if="config.table.selectBtn">
                            已选<span class="text-color">&nbsp;&nbsp;{{checkedNum}}&nbsp;&nbsp;</span>项
                        </div>
                        <slot name="page-module-btn"></slot>
                    </el-col>
                    <el-col :span="12" v-if="!config.transferTables">
                        <m-page ref="page" :pageData="config.page" :total="pageTotal" @on-page-change="pageChange" @on-size-change="sizeChange"></m-page>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
import mSearchList from '../../../../../components/mulitPanel/mSearchList';
import mTable from '../../../../../components/mulitPanel/mTable';
import mPage from '@/components/awesome/page/mPanel3/mPage';
import configuration from '@/components/awesome/page/mPanel3/configuration-list';
import getList from '@/components/awesome/page/mPanel3/api';
import { mapGetters } from 'vuex';

export default {
    name: 'sieveSingleCenterPanel',
    components: { mTable, mSearchList, mPage, configuration },
    computed: {
        ...mapGetters(['menus'])
    },
    data() {
        return {
            sourceCurrent: '',
            targetCurrent: '',
            checkedNum: 0,
            startMove: 0,
            endMoveWidth: 0,
            endListMoveHeight: 0,
            showModal: false,
            tableList: '',
            suanfaTableList: '',
            settingColumns: this.config.table.columns,
            checkedList: '',
            pageState: true,
            popPrefix: this.config.popPrefix ? this.config.popPrefix : '/api-mdm/dictionaryDetail/dict',
            advancePrefix: this.config.advancePrefix ? this.config.advancePrefix : '/api-mdm',
            longPrefix: this.config.longPrefix ? this.config.longPrefix : '/api-gwms/es/comboBox',
            configurationUrl: this.config.configurationUrl ? this.config.configurationUrl : '/api-auth',
            resourceCode: '',
            targetLoading: false,
            suanfaLoading: false,
            sourceLoading: false,
            sourceTreeLoading: false,
            targetTreeLoading: false,
            activeName: 'first',
            startTableMove: 0,
            endTableMove: 0,
            endMoveHeight: 0
        };
    },
    props: {
        config: Object,
        totalData: Array,
        totalSuanfaData: Array,
        totalTargetData: Array,
        sourceRootData: Array,
        targetRootData: Array,
        pageTotal: Number,
        sourceTitle: String,
        targetTitle: String,
        dataSourceUrl: String,
        pageID: String,
        searchId: String,
        optionNum: String,
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        method: {
            type: String,
            default: 'get'
        },
        searchTotalTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        searchSetTitle: {
            type: Array,
            default() {
                return [];
            }
        },
        columnNum: Number,
        mulSourceSel: Boolean,
        initSearchInfo: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.path) {
                            this.resourceCode = childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        allocationBtn (data) {
            this.$emit('allocation-btn', data);
        },
        removeBtn (data) {
            this.$emit('remove-btn', data);
        },
        appointmentBranchBtn (data) {
            this.$emit('appointmentBranch-btn', data);
        },
        rescheduledBranchBtn (data) {
            this.$emit('rescheduledBranch-btn', data);
        },
        reschedulingBtn (data) {
            this.$emit('rescheduling-btn', data);
        },
        // 表格中按钮触发事件
        checkTable(data) {
            this.$emit('check-btn', data);
        },
        editTable(data) {
            this.$emit('edit-btn', data);
        },
        printTable(data) {
            this.$emit('print-btn', data);
        },
        delTable(data) {
            this.$emit('del-btn', data);
        },
        allocateTable(data) {
            this.$emit('allocate-btn', data);
        },
        cancleAllocateTable(data) {
            this.$emit('cancleAllocate-btn', data);
        },
        saveData(data) {
            this.$emit('saveData', data);
        },
        // 表单选项变化
        sourceSelectChange(data) {
            this.$emit('source-select-change', data);
            this.checkedNum = data.length;
        },
        rowDBClick(row) {
            this.$emit('row-db-click', row);
        },
        // 搜索内容变化
        searchChange(data) {
            this.$emit('searchChange', data);
        },
        // 搜索值单项变化
        searchListChange(config, data) {
            this.$emit('search-list-change', config, data);
        },
        // 搜索值单项变化
        searchSetChange (data) {
            this.$emit('searchSet-change', data);
        },
        // 分页器改变触发事件
        pageChange(page) {
            this.$emit('pageChange', page);
        },
        sizeChange(size) {
            this.$emit('sizeChange', size);
        },
        btnClick (val, index, row, columnsName) {
            this.$emit('btnClick', val, index, row, columnsName);
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            if (this.config.configuration) {
            } else {
                this.showModal = false;
                const pramas = {
                    'configName': tabelConfigName,
                    'configNameCn': tabelConfigList,
                    'subjectType': this.pageID,
                    'moduleCode': this.resourceCode
                };
                getList.post(this.configurationUrl, pramas).then(() => {});
                this.tableList = tabelConfigList;
            }
        },
        tableConfigClose() {
            this.showModal = false;
        },
        dialogClose() {
            this.$refs.dialog.initData();
        },
        // 获取表格头保存参数
        async getTableTitle() {
            if (this.config.configuration) {
                return new Promise((resolve) => {
                    resolve(() => {
                        this.checkedList = '';
                    });
                });
            } else {
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                let allColumns = [];
                let allColumnsprop = [];
                this.config.table.columns.map((item, index) => {
                    if (this.columnNum && index >= this.columnNum) {
                    } else {
                        allColumns.push(item.label);
                        allColumnsprop.push(item.prop);
                    }
                });
                allColumns = allColumns.join(',');
                allColumnsprop = allColumnsprop.join(',');
                const pramas = {
                    'configName': allColumnsprop,
                    'configNameCn': allColumns,
                    'moduleCode': this.resourceCode,
                    'subjectType': this.pageID
                };
                return getList.get(this.configurationUrl, pramas).then(data => {
                    if (data.data) {
                        this.checkedList = data.data.configNameCn;
                    } else {
                        this.checkedList = allColumns;
                    }
                }).catch(() => {
                    this.checkedList = allColumns;
                });
            }
        },
        initTitleList() {
            let laberString = [];
            if (this.checkedList === '') {
                this.config.table.columns.map(data => {
                    laberString.push(data.label);
                });
                laberString = laberString.join(',');
                this.tableList = laberString;
            } else {
                this.tableList = this.checkedList;
            }
        },
        getTitleList() {
            return this.getTableTitle().then(() => {
                this.showModal = true;
            });
        },
        // 表格内高级搜索
        tabAdvancedSearch(data, item, type, searchData) {
            this.$refs.searchList.detaliSearch(data, item, type, searchData);
        },
        tableAdvance(prop, advanceCode, data, code) {
            this.$refs.table.ruleForm[prop] = data;
            this.$refs.table.ruleForm[advanceCode] = code;
        },
        columnFilterSearch(data) {
            this.$refs.searchList.onSearchChange(data);
        },
        statusChange(status) {
            this.$refs.table.changeStatu(status);
        },
        changeLoading(status) {
            this.$refs.searchList.changeLoading(status);
        },
        moreAction(selection, index) {
            this.$emit('moreAction', selection, index);
        },
        rootListClick(item, to, index) {
            this.$emit('root-click', item, to);
            this.sourceCurrent = to + index;
        },
        mousedownLRWidth(e) {
            this.startMove = e.clientX;
            var distance = 0;
            document.onmousemove = (ev) => {
                var thisEvent = ev || event;
                distance = this.startMove - thisEvent.clientX;
                if (distance + this.endMoveWidth >= 100) {
                    distance = 0;
                    this.endMoveWidth = 100;
                    return;
                }
                if (distance + this.endMoveWidth <= -20) {
                    distance = 0;
                    this.endMoveWidth = -20;
                    return;
                }
                this.$refs.allTableLeft.style.width = `calc(198px - ${this.endMoveWidth}px - ${distance}px)`;
                this.$refs.allTableRight.style.width = `calc(100% - ${this.$refs.allTableLeft.style.width})`;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.endMoveWidth = this.endMoveWidth + distance;
            };
        },
        initActiveChange() {
            this.sourceCurrent = '';
        },
        cellDblclick(row, column, cell, event) {
            this.$emit('cellDblclick', row, column, cell, event);
        },
        sourceRowClick(row) {
            this.$emit('sourceRowClick', row);
        },
        sourceSelect(selection, row) {
            this.$emit('sourceSelect', selection, row);
        },
        sourceSelectAll(selection) {
            this.$emit('sourceSelectAll', selection);
        },
        refreshTarget() {
            this.$emit('refreshTarget');
        },
        handleEditCount() {
            this.$emit('handleEditCount');
        }
    },
    mounted() {
        this.$refs.allTableLeft.style.width = '198px';
        this.getTableTitle().then(() => {
            this.initTitleList();
        });
    }
};
</script>
<style lang="less">
@import './mpanel.less';
</style>
